import { memo } from 'react';
import { withRole } from '../Common/withRole';
import { PrimaryButton } from '../Common/BaseButton';
import { Plus } from 'lucide-react';
import styled from 'styled-components';

const ButtonWrapper = styled.div`
  width: fit-content;
  @media (max-width: 500px) {
    margin-top: 12px;
    width: 100%;
  }
`;

const AddButtonContent = memo(({ onClick }) => (
  <ButtonWrapper>
  <PrimaryButton onClick={onClick} style={{width: '100%'}}>
    <Plus size={16} />
    Add New Event
  </PrimaryButton>
  </ButtonWrapper>
));

const WithRoleAddButton = withRole(AddButtonContent, { 
  managerOnly: true
});

const AddNewEventButton = memo(({ onClick, isManager, isAuthenticated }) => {
  return (
    <WithRoleAddButton 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      onClick={onClick}
    />
  );
});

export default AddNewEventButton;